import { createPinia } from 'pinia'
import { watch as _vueWatch } from 'vue' // IE 2026 08 20 / ODOO-336291 (mobile UX)
import { GlobalCmComponent } from "codemirror-editor-vue3";

// import 'bootstrap/dist/css/bootstrap.css';
// import '../node_modules/@mescius/wijmo.styles/wijmo.css';
// import './assets/styles/sass/buttons.less';

import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import './assets/styles/layout.scss';
import './assets/styles/mobile-ui.css'; // IE 2026 08 20 / ODOO-336291 (mobile UX)
import './assets/styles/ie-icons.css'; // IE 2026 09 13 / ODOO-335246 (Igor): иконки вкладок схемы каскада (SVG-маски)
import './assets/styles/ie-icons-platform.css'; // IE 2026 09 13 / ODOO-… (заказ Игоря): пользовательские иконки остальной платформы (SVG-маски ie-ico-*)
import './assets/styles/ie-icon-schemes.css'; // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): Material Symbols / Font Awesome 4 / Star Wars Glyph Icons поверх primeicons
import './assets/styles/toggle-chips.css'; // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз)
import './assets/demo/flags/flags.css';

import { createApp, reactive, defineAsyncComponent } from 'vue';

import router from './router';
import AppWrapper from './AppWrapper.vue';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
// import Chips from 'primevue/chips';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
// import Dropdown from 'primevue/dropdown';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import Image from 'primevue/image';
import InlineMessage from 'primevue/inlinemessage';
import Inplace from 'primevue/inplace';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import Knob from 'primevue/knob';
import Galleria from 'primevue/galleria';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import ScrollPanel from 'primevue/scrollpanel'
import ScrollTop from 'primevue/scrolltop';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import Skeleton from 'primevue/skeleton';
import SplitButton from 'primevue/splitbutton';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Steps from 'primevue/steps';
import StyleClass from 'primevue/styleclass';
import TabMenu from 'primevue/tabmenu';
import Tag from 'primevue/tag';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Timeline from 'primevue/timeline';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';

import CodeHighlight from './AppCodeHighlight';
import BlockViewer from './BlockViewer';

import vVisible from './directives/v-visible.js';

import { registerChart } from '@mescius/wijmo.vue2.chart';
import { registerChartAnalytics } from '@mescius/wijmo.vue2.chart.analytics';
import { registerChartAnimation } from '@mescius/wijmo.vue2.chart.animation';
import { registerChartAnnotation } from '@mescius/wijmo.vue2.chart.annotation';
import { registerChartFinance } from '@mescius/wijmo.vue2.chart.finance';
import { registerChartHierarchical } from '@mescius/wijmo.vue2.chart.hierarchical';
import { registerChartInteraction } from '@mescius/wijmo.vue2.chart.interaction';
import { registerChartRadar } from '@mescius/wijmo.vue2.chart.radar';
import { registerCore } from '@mescius/wijmo.vue2.core';
import { wjTooltipFn } from './utils/altTooltip'; // IE 2026 09 07 / ODOO-337259: «ленивые» подсказки — контент при показе (Alt / Show tooltips)
import { uiHelpDirective } from './utils/uiHelp'; // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): v-uiHelp — объяснение элемента (что это, зачем, на что влияет) по Alt / Show tooltips
import { registerGauge } from '@mescius/wijmo.vue2.gauge';
import { registerGrid } from '@mescius/wijmo.vue2.grid';
import { registerGridDetail } from '@mescius/wijmo.vue2.grid.detail';
import { registerGridFilter } from '@mescius/wijmo.vue2.grid.filter';
import { registerGridGrouppanel } from '@mescius/wijmo.vue2.grid.grouppanel';
import { registerGridMultirow } from '@mescius/wijmo.vue2.grid.multirow';
import { registerGridSearch } from '@mescius/wijmo.vue2.grid.search';
import { registerGridSheet } from '@mescius/wijmo.vue2.grid.sheet';
import { registerGridTransposed } from '@mescius/wijmo.vue2.grid.transposed';
import { registerGridTransposedMultirow } from '@mescius/wijmo.vue2.grid.transposedmultirow';
import { registerInput } from '@mescius/wijmo.vue2.input';
import { registerNav } from '@mescius/wijmo.vue2.nav';
import { registerOlap } from '@mescius/wijmo.vue2.olap';
import { registerViewer } from '@mescius/wijmo.vue2.viewer';

// import VueShortkey from 'vue-shortkey'; // npm install vue-shortkey --save  npm install --save vue-hotkey

wijmo.setLicenseKey(process.env.VUE_APP_WIJMO_LICENSE_KEY);

import WidgetAttrs from './components/widgets/WidgetAttrs.vue';
import Widget from './components/widgets/Widget.vue';
import MenuPanel from './components/MenuPanel.vue'; // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): панель функций в стиле 1С — ≡ виджета, ≡ таблицы, меню пользователя
import AttrTab from './components/widgets/components_core/AttrTab.vue';
import AttrTabRow from './components/widgets/components_core/AttrTabRow.vue';
import Attr from './components/widgets/components_core/Attr.vue';
import AttrStr from './components/widgets/components_core/AttrStr.vue';
import AttrHTML from './components/widgets/components_core/AttrHTML.vue';
import ApprovalOverview from './components/widgets/components_core/ApprovalOverview.vue';   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE3: картина согласования (вкладка Approval отчёта, виджет approval-overview страницы)
import AttrLabel from './components/widgets/components_core/AttrLabel.vue';
import AttrSeparator from './components/widgets/components_core/AttrSeparator.vue';
import AttrFlowchart from './components/widgets/components_core/AttrFlowchart.vue';
import AttrLink from './components/widgets/components_core/AttrLink.vue';
import AttrLinkOdoo from './components/widgets/components_core/AttrLinkOdoo.vue';
import AttrBool from './components/widgets/components_core/AttrBool.vue';
import AttrButton from './components/widgets/components_core/AttrButton.vue';
import AttrMenu from './components/widgets/components_core/AttrMenu.vue';
import AttrCommandPanel from './components/widgets/components_core/AttrCommandPanel.vue';
import AttrNumber from './components/widgets/components_core/AttrNumber.vue';
import AttrDate from './components/widgets/components_core/AttrDate.vue';
import AttrTime from './components/widgets/components_core/AttrTime.vue';
import AttrGrid from './components/widgets/components_core/AttrGrid.vue';
import AttrTabGridLanes from './components/widgets/components_core/AttrTabGridLanes.vue';
import AttrGridGroup from './components/widgets/components_core/AttrGridGroup.vue';
import AttrCrossGrid from './components/widgets/components_core/AttrCrossGrid.vue';   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — AttrCrossGrid)
import AttrSheet from './components/widgets/components_core/AttrSheet.vue';
import AttrTree from './components/widgets/components_core/AttrTree.vue';
import AttrGantt from './components/widgets/components_core/AttrGantt.vue';
import AttrTabPanel from './components/widgets/components_core/AttrTabPanel.vue';
import AttrJSON from './components/widgets/components_core/AttrJSON.vue';
import AttrImage from './components/widgets/components_core/AttrImage.vue';
import AttrUrl from './components/widgets/components_core/AttrUrl.vue';   // IE 2026 10 18 / ODOO-347310
import AttrImageUrl from './components/widgets/components_core/AttrImageUrl.vue';   // IE 2026 10 18 / ODOO-347310
import AttrFileViewer from './components/widgets/components_core/AttrFileViewer.vue';
import AttrCSS from './components/widgets/components_core/AttrCSS.vue';
import AttrMD from './components/widgets/components_core/AttrMD.vue';
import AttrStrMulti from './components/widgets/components_core/AttrStrMulti.vue';
import AttrDebugger from './components/widgets/components_core/AttrDebugger.vue';
import AttrChat from './components/widgets/components_core/AttrChat.vue';
import AttrChart from './components/widgets/components_core/AttrChart.vue';
import AttrBubbleChart from './components/widgets/components_core/AttrBubbleChart.vue';
import AttrGeoMap from './components/widgets/components_core/AttrGeoMap.vue';   // IE 2026 09 14 / ODOO-5800: карта стран (wijmo FlexMap)
import AttrGanttMoves from './components/widgets/components_core/AttrGanttMoves.vue';
import AttrTransitionsGraph from './components/widgets/components_core/AttrTransitionsGraph.vue';   // IE 2026 10 16 / ODOO-5800 (поручение Игоря 16.10): граф переходов статусов вкладки Transitions политики
import AttrAnalysis from './components/widgets/components_core/AttrAnalysis.vue';   // IE 2026 09 22 / ODOO-5800: вкладка «Analysis» форм документов движений (паспорт по документу)   // IE 2026 09 22 / ODOO-5800: диаграмма Ганта движений (вкладка Gantt списка над витриной оборотов)
import AttrAntFlow from './components/widgets/components_core/AttrAntFlow.vue';   // IE 2026 09 15 / ODOO-… (заказ Игоря): «муравьиная логистика» — режим чарта AntFlow
import AttrBubbleWithAnimationChart from './components/widgets/components_core/AttrBubbleWithAnimationChart.vue';
import AttrTreeMap from './components/widgets/components_core/AttrTreeMap.vue';
import AttrPivotTool from './components/widgets/components_core/AttrPivotTool.vue';
import EmptyIcon from './components/icons/EmptyIcon.vue';
import AttrGraph from './components/widgets/components_core/AttrGraph.vue';
import AttrSchemeGraph from './components/widgets/components_core/AttrSchemeGraph.vue';   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф связей схемы — AttrSchemeGraph)
import GraphEngineToggle from './components/widgets/components_core/graph/lens/GraphEngineToggle.vue';   // Odoo 348733: переключатель движка графа «Classic / Lens» (без three.js — в основном чанке)
import AttrCompare from './components/widgets/components_core/AttrCompare.vue';
import AttrStyleStats from './components/widgets/components_core/AttrStyleStats.vue';   // IE 2026 09 18 / ODOO-… (заказ Игоря): вкладка Styles — статистика и отбор по стилям
import AttrTasksPanel from './components/widgets/components_core/AttrTasksPanel.vue';   // IE 2026 09 23 / ODOO-… (заказ Игоря): вкладка «Tasks panel» формы стола — doc.data_tasks панелью функций
import AttrUseCaseMenu from './components/widgets/components_core/AttrUseCaseMenu.vue';   // IE 2026 09 28 / ODOO-342342 (Use cases): вкладка Contents формы USE-CASE — навигатор кейсов формой-меню
import AttrChips from './components/widgets/components_core/AttrChips.vue';
import Dropdown from './components/widgets/Dropdown.vue';
import Search from './components/widgets/Search.vue';

import { createVueCallgraphPlugin } from './components/utils/vue-callgraph-plugin.js';
import { CallGraph } from './components/utils/callgraph.js'
import { piniaCallgraphPlugin } from './components/utils/pinia-callgraph.js';

// IE 2026 09 23 / ODOO-341407: культура wijmo и словарь интерфейса грузятся по языку пользователя ДО монтирования (см. src/i18n);
// прежний статический импорт wijmo.culture.uk давал украинские строки контролов при английском UI
import { i18nInit, t as i18n_t, tn as i18n_tn, getLanguage, getLocale, resetLanguage, missing as i18nMissing, i18nStats, registerPrimeVue } from '@/i18n'   // IE 2026 09 24 / ODOO-341407: registerPrimeVue — локаль PrimeVue меняется вживую при переключении языка
import { installSwitchConsole as i18nSwitchConsole } from '@/i18n/relocalize'   // IE 2026 09 25 / ODOO-341407: window.i18nSwitch — флаги ускорений живого переключения и замеры
import { tabsLazy_console } from '@/utils/tabsLazy'   // IE 2026 09 26 / ODOO-5800: window.tabsLazy — флаги ленивых скрытых вкладок и замеры
import { gridEmptyScan_console } from '@/utils/gridEmptyScan'   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): window.gridEmptyScan — выключатель fe.ux.gridEmptyScanCache и счётчики
import { gridAutoSizeRows_console } from '@/utils/gridAutoSizeRows'   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): window.gridAutoSizeRows — выключатель fe.ux.gridAutoSizeRowsLazy и счётчики
import { editCommit_console } from '@/utils/editCommit'   // IE 2026 10 14 / ODOO-345813 (заказ Игоря: окна остановок регламента): window.editCommit — выключатель fe.ux.commitEditsBeforeAction и счётчики
import { netCancel_console } from '@/utils/netCancel'   // IE 2026 09 26 / ODOO-5800: window.netCancel — флаги отмены запросов (fe.net.*) и замеры
import { helpDocs_console } from '@/utils/docsNav'   // IE 2026 09 28 / ODOO-342342: window.helpDocs — флаг fe.help.inPlaceDocs (читалки документации листают на месте) и замеры
import { settingsFormLazy_console } from '@/utils/settingsFormLazy'   // IE 2026 09 28 / ODOO-5800: window.settingsFormLazy — форма настроек виджета по требованию: флаги и замеры
import { docsSearch_console } from '@/utils/docsSearch'   // IE 2026 09 28 / ODOO-342342: window.helpDocs.search() — замеры меню читалки (fe.help.docsSearch)
import { guideCases_console } from '@/utils/guideCases'   // IE 2026 09 28 / ODOO-342342 (Use cases): window.guideCases — флаги fe.guide.cases / fe.guide.chipsOnOpen и замеры
import { useMainStore, COLOR_SCHEMES, normalizeColorScheme, initialColorScheme, mobileAuto, initialIconScheme, applyIconSchemeClasses } from '@/stores/mainStore'  // IE 2026 09 04 / ODOO-336330: mobileAuto — единое правило авто-детекта
import * as selectionHighlight from '@/stores/selectionHighlight'

// Цветовые настройки применяем ДО createApp — это самая ранняя точка, где уже
// есть DOM: если ждать инициализации store/AppTopbar, на старте видно вспышку
// классической светлой гаммы. Ключи те же, что в mainStore.saveColorSettings.
// normalizeColorScheme валидирует id и мигрирует старое 'style2' → 'style2o'.
// IE 2026 08 23 (заказ Игоря): мобильный профиль без явно выбранной гаммы — style6m
const savedColorScheme = initialColorScheme();
const savedDarkTheme = localStorage.getItem('webscm_darkTheme'); // null = выбора не было, решает prefers-color-scheme
if (document.body) {
    // та же логика, что в applyColorScheme: снять все прежние cscheme-*, повесить актуальный
    COLOR_SCHEMES.forEach(s => document.body.classList.remove(`cscheme-${s.id}`));
    document.body.classList.add(`cscheme-${savedColorScheme}`);
}
// IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): классы схемы иконок на body тоже до createApp — иначе вспышка классических иконок
applyIconSchemeClasses(initialIconScheme());

// IE 2026 08 20 / ODOO-336291 (mobile UX): класс мобильного профиля — до createApp,
// та же логика, что в mainStore.mobileUi.on (источник истины там)
try {
    const _mu = JSON.parse(localStorage.getItem('mobileUi') || '{}')
    const _auto = mobileAuto()   // IE 2026 09 04 / ODOO-336330: пороги 480/820 — настройки базы (зеркало localStorage)
    let _on = _mu.enabled == null ? _auto : !!_mu.enabled
    const _m = /[?&#]mobile=([01])/.exec(location.href)
    if (_m) _on = _m[1] === '1'
    if (_on && _mu.bigTargets !== false) document.body.classList.add('mobile-ui')
} catch (e) { /* мобильный профиль не критичен для входа */ }

// IE 2026 08 20 / ODOO-336291 (mobile UX) (Safari/iPhone): shell-lock класс до createApp;
// тулбар Safari в цвет активной гаммы: iOS 15-18 красят по meta theme-color
// (живое обновление поддержано), iOS 26 СЭМПЛИРУЕТ фон страницы — прозрачный
// body упал бы в белый/чёрный, задаём фон явно
try {
    const _mu2 = JSON.parse(localStorage.getItem('mobileUi') || '{}')
    if (document.body.classList.contains('mobile-ui') && _mu2.shellLock !== false)
        document.body.classList.add('shell-lock')
    // IE 2026 08 23 (заказ Игоря): лента-карточки стола (дефолт ВКЛ)
    if (document.body.classList.contains('mobile-ui') && _mu2.cardsBoard !== false)
        document.body.classList.add('mob-cards')
    // IE 2026 09 04 / ODOO-336291 (mobile UX): P-10 gridPanChain — CSS-часть scroll chaining (дефолт ВКЛ)
    if (document.body.classList.contains('mobile-ui') && _mu2.gridPanChain !== false)
        document.body.classList.add('mob-chain')
    // IE 2026 09 04 / ODOO-336291 (mobile UX): CSS-части флагов пакета FE-2 (дефолты ВКЛ; снимаются window.mobileUi.set('<flag>', false))
    if (document.body.classList.contains('mobile-ui')) {
        if (_mu2.fabsOneTap !== false) document.body.classList.add('mob-onetap')       // B-06: хвост FAB ≥ 24 px
        if (_mu2.fabsPad !== false) document.body.classList.add('mob-fabspad')         // B-11: отступ карточки от FAB
        if (_mu2.pressFeedback !== false) document.body.classList.add('mob-press')     // P-25: :active-отклик
        if (_mu2.fastTransitions !== false) document.body.classList.add('mob-fast')    // P-26: короткие транзиции
        if (_mu2.hdrWordWrap !== false) document.body.classList.add('mob-hdrwrap')     // B-34: заголовки без разрыва слова
        if (_mu2.railRowHit !== false) document.body.classList.add('mob-railhit')      // полоса строки рейла страниц кликабельна целиком
        // IE 2026 09 04 / ODOO-336291 (mobile UX): CSS-части флагов пакета FE-4 (дефолты ВКЛ)
        if (_mu2.chartCompact !== false) document.body.classList.add('mob-chartc')     // B-40: читаемая раскладка графика
        if (_mu2.gridGlyphTouch !== false) document.body.classList.add('mob-gridglyph') // B-21: глифы грида под палец
        if (_mu2.settingsCompact !== false) document.body.classList.add('mob-setgrid') // B-39: грид настроек по-мобильному
        if (_mu2.railGroupStyle !== false) document.body.classList.add('mob-railgrp')  // группы страниц в рейле
        if (_mu2.fabUniform !== false) document.body.classList.add('mob-fabuni')       // B-32: единый стиль колонки FAB
    }
    const _syncSafariChrome = () => {
        try {
            const cs = getComputedStyle(document.body)
            const accent = (cs.getPropertyValue('--cs-accent') || '').trim() || '#6477ef'
            document.querySelector('meta[name="theme-color"]')?.setAttribute('content', accent)
            if (cs.backgroundColor === 'rgba(0, 0, 0, 0)' || cs.backgroundColor === 'transparent')
                document.body.style.backgroundColor = '#ffffff'
        } catch (e) { /* не критично */ }
    }
    _syncSafariChrome()
    new MutationObserver(_syncSafariChrome).observe(document.body, { attributes: true, attributeFilter: ['class'] })
} catch (e) { /* Safari-хром не критичен для входа */ }

// (async () => {
//     const lang = (navigator.language || 'en').split('-')[0];
//     try {
//         await import(`@mescius/wijmo.culture.${lang}`);
//         console.log(`✅ Wijmo culture applied: ${lang}`);
//     } catch (e) {
//         console.warn(`⚠️ Wijmo culture for "${lang}" not found`);
//     }
    
    let use_callgraph = true;
    const cg = new CallGraph({ showRecursion:false, maxPathDepth:1, minTotalMs:0 });

    const i18nReady = i18nInit()   // IE 2026 09 23 / ODOO-341407: язык + словарь + культура wijmo — до app.mount
    const app = createApp(AppWrapper);

    registerChart(app);
    registerChartAnalytics(app);
    registerChartAnimation(app);
    registerChartAnnotation(app);
    registerChartFinance(app);
    registerChartHierarchical(app);
    registerChartInteraction(app);
    registerChartRadar(app);
    registerCore(app);
    app.directive('wjTooltipFn', wjTooltipFn); // IE 2026 09 07 / ODOO-337259: v-wjTooltipFn="fn" — контент подсказки считается в момент показа
    app.directive('uiHelp', uiHelpDirective); // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): v-uiHelp="'ключ'" | { key, state, vars } — реестр utils/uiHelp/index.js, выключатель fe.ux.uiHelp
    registerGauge(app);
    registerGrid(app);
    registerGridDetail(app);
    registerGridFilter(app);
    registerGridGrouppanel(app);
    registerGridMultirow(app);
    registerGridSearch(app);
    registerGridSheet(app);
    registerGridTransposed(app);
    registerGridTransposedMultirow(app);
    registerInput(app);
    registerNav(app);
    registerOlap(app);
    registerViewer(app);

    // darkTheme засеваем сохранённым значением, чтобы AppTopbar не мигнул светлой темой
    app.config.globalProperties.$appState = reactive({ theme: 'lara-light-indigo', darkTheme: savedDarkTheme === 'true' });
    app.config.globalProperties.t = i18n_t     // IE 2026 09 23 / ODOO-341407: t('English text') в шаблонах и методах компонентов
    app.config.globalProperties.tn = i18n_tn   // IE 2026 09 23 / ODOO-341407: tn(n, '{n} row', '{n} rows') — множественное число

    // app.use(VueShortkey);
    app.use(GlobalCmComponent);

    app.use(PrimeVue, { ripple: true, inputStyle: 'outlined' });
    // IE 2026 09 23 / ODOO-341407: локаль PrimeVue по языку — поверх встроенной английской (Object.assign в реактивный
    // config.locale: ключи, которых нет в нашей локали, остаются английскими; передача locale в app.use затирала бы
    // дефолт целиком — компонент Password падал на locale.passwordPrompt)
    // IE 2026 09 24 / ODOO-341407: регистрация реактивной локали (английский снимок + наложение uk/ru; при переключении языка без reload — заново)
    registerPrimeVue(app.config.globalProperties.$primevue.config.locale)
    app.use(ConfirmationService);
    app.use(ToastService);
    app.use(router);

    app.directive('tooltip', Tooltip);
    app.directive('ripple', Ripple);
    app.directive('code', CodeHighlight);
    app.directive('badge', BadgeDirective);
    app.directive('styleclass', StyleClass);
    app.directive('visible', vVisible)

    app.component('Accordion', Accordion);
    app.component('AccordionTab', AccordionTab);
    app.component('AutoComplete', AutoComplete);
    app.component('Avatar', Avatar);
    app.component('AvatarGroup', AvatarGroup);
    app.component('Badge', Badge);
    app.component('Breadcrumb', Breadcrumb);
    app.component('Button', Button);
    app.component('Calendar', Calendar);
    app.component('Card', Card);
    app.component('Carousel', Carousel);
    app.component('Chart', Chart);
    app.component('Checkbox', Checkbox);
    app.component('Chip', Chip);
    // app.component('Chips', Chips);
    app.component('ColorPicker', ColorPicker);
    app.component('Column', Column);
    app.component('ConfirmDialog', ConfirmDialog);
    app.component('ConfirmPopup', ConfirmPopup);
    app.component('ContextMenu', ContextMenu);
    app.component('DataTable', DataTable);
    app.component('DataView', DataView);
    app.component('DataViewLayoutOptions', DataViewLayoutOptions);
    app.component('Dialog', Dialog);
    app.component('Divider', Divider);
    // app.component('Dropdown', Dropdown);
    app.component('Fieldset', Fieldset);
    app.component('FileUpload', FileUpload);
    app.component('Image', Image);
    app.component('InlineMessage', InlineMessage);
    app.component('Inplace', Inplace);
    app.component('InputMask', InputMask);
    app.component('InputNumber', InputNumber);
    app.component('InputSwitch', InputSwitch);
    app.component('InputText', InputText);
    app.component('Galleria', Galleria);
    app.component('Knob', Knob);
    app.component('Listbox', Listbox);
    app.component('MegaMenu', MegaMenu);
    app.component('Menu', Menu);
    app.component('Menubar', Menubar);
    app.component('Message', Message);
    app.component('MultiSelect', MultiSelect);
    app.component('OrderList', OrderList);
    app.component('OrganizationChart', OrganizationChart);
    app.component('OverlayPanel', OverlayPanel);
    app.component('Paginator', Paginator);
    app.component('Panel', Panel);
    app.component('PanelMenu', PanelMenu);
    app.component('Password', Password);
    app.component('PickList', PickList);
    app.component('ProgressBar', ProgressBar);
    app.component('RadioButton', RadioButton);
    app.component('Rating', Rating);
    app.component('SelectButton', SelectButton);
    app.component('ScrollPanel', ScrollPanel);
    app.component('ScrollTop', ScrollTop);
    app.component('Slider', Slider);
    app.component('Sidebar', Sidebar);
    app.component('Skeleton', Skeleton);
    app.component('SplitButton', SplitButton);
    app.component('Splitter', Splitter);
    app.component('SplitterPanel', SplitterPanel);
    app.component('Steps', Steps);
    app.component('TabMenu', TabMenu);
    app.component('TabView', TabView);
    app.component('TabPanel', TabPanel);
    app.component('Tag', Tag);
    app.component('Textarea', Textarea);
    app.component('TieredMenu', TieredMenu);
    app.component('Timeline', Timeline);
    app.component('Toast', Toast);
    app.component('Toolbar', Toolbar);
    app.component('ToggleButton', ToggleButton);
    app.component('Tree', Tree);
    app.component('TreeSelect', TreeSelect);
    app.component('TreeTable', TreeTable);
    app.component('TriStateCheckbox', TriStateCheckbox);
    app.component('BlockViewer', BlockViewer);

    const pinia = createPinia();
    if (use_callgraph) {
        pinia.use(piniaCallgraphPlugin(cg));
    }
    app.use(pinia);

    const store = useMainStore()
    store.cg = cg
    store.initAjaxDefaults()

    // «Скоростной вход»: консольный тумблер опций R1..R6 (см. mainStore.fastEntry).
    // fastEntry.set('holdTitles', false) действует сразу и переживает reload
    window.fastEntry = {
        get: () => JSON.parse(JSON.stringify(store.fastEntry)),
        set(name, value) {
            if (!(name in store.fastEntry)) {
                console.warn(`fastEntry: no option '${name}'. Options:`, Object.keys(store.fastEntry))
                return
            }
            store.fastEntry[name] = value
            const saved = (() => { try { return JSON.parse(localStorage.getItem('fastEntry') || '{}') } catch (e) { return {} } })()
            saved[name] = value
            localStorage.setItem('fastEntry', JSON.stringify(saved))
            return this.get()
        },
        reset() { localStorage.removeItem('fastEntry'); location.reload() },
    }

    // IE 2026 09 04 / ODOO-336330: глобальные настройки БАЗЫ на фронте.
    //   feSettings.get()            → {db, override, version} — что пришло с бэка и что переопределено
    //   feSettings.get('fe.x.y')    → эффективное значение ключа (override → база → кодовый дефолт)
    //   feSettings.set('fe.x.y', v) → override ЭТОГО браузера (переживает reload), сильнее значения базы
    //   feSettings.reset()          → снять все override и перезагрузить страницу
    // Значения базы правит администратор в записи SETTINGS (вкладка Frontend / Mobile) —
    // пересборка фронта для этого не нужна, значение приезжает в ответе бэка.
    // IE 2026 09 23 / ODOO-341407: консольный хелпер языка интерфейса: get() / set('uk') / reset() / missing() (строки без перевода) / stats()
    window.i18n = {
        get: () => getLanguage(),
        locale: () => getLocale(),
        set: (id) => store.set_language(id) || 'unknown language',   // IE 2026 09 24 / ODOO-341407: тот же путь, что меню пользователя — без перезагрузки (флаг fe.i18n.switchWithoutReload)
        reset: () => { resetLanguage(); location.reload() },
        missing: () => i18nMissing(),
        stats: () => i18nStats(),
        t: i18n_t, tn: i18n_tn,
    }
    // IE 2026 09 25 / ODOO-341407: флаги живого переключения языка (каждое ускорение / исправление — свой флаг, по умолчанию вкл.) и замеры:
    // i18nSwitch.get() / .help() / .set('switchNoRepeat', false) / .reset() / .last() — фазы последнего переключения
    i18nSwitchConsole(store)
    window.feSettings = {
        get: (k) => k ? store.setting(k) : {
            version: store.settings_version,
            db: JSON.parse(JSON.stringify(store.settings || {})),
            override: { ...(store._settingsOverride || {}) },
        },
        set(k, v) {
            if (!String(k).startsWith('fe.')) { console.warn("feSettings.set: key must start with 'fe.'"); return }
            store.setting(k)                       // прогреть ленивую склейку override
            store._settingsOverride[k] = v
            try { localStorage.setItem('feSettings', JSON.stringify(store._settingsOverride)) } catch (e) { /* приватный режим */ }
            store._settingsEpoch++
            return store.setting(k)
        },
        unset(k) {
            store.setting(k)
            delete store._settingsOverride[k]
            try { localStorage.setItem('feSettings', JSON.stringify(store._settingsOverride)) } catch (e) { /* приватный режим */ }
            store._settingsEpoch++
            return store.setting(k)
        },
        reset() { localStorage.removeItem('feSettings'); location.reload() },
    }
    // IE 2026 09 26 / ODOO-5800: ленивые скрытые вкладки — fe.ux.tabsLazyHidden / fe.ux.gridDictPrefetchVisibleOnly (по умолчанию вкл.):
    // tabsLazy.get() / .set('tabsLazyHidden', false) / .reset() / .stats() / .clear() — см. utils/tabsLazy.js
    tabsLazy_console(store)
    gridEmptyScan_console(store)   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): gridEmptyScan.get() / .set(false) / .reset() / .stats() / .clear()
    gridAutoSizeRows_console(store)   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): gridAutoSizeRows.get() / .set(false) / .reset() / .stats() / .clear()
    editCommit_console(store)   // IE 2026 10 14 / ODOO-345813 (заказ Игоря: окна остановок регламента): правка ячейки формы — в запись до действия (вкладка Preview, кнопки); editCommit.get() / .set(false) / .stats()
    // IE 2026 09 26 / ODOO-5800: отмена запросов бэка — номер действия уникален на вкладку, безопасный 204, выключатель ключа отмены бэка:
    // netCancel.get() / .set('actionIdUnique', false) / .reset() / .stats() — см. utils/netCancel.js
    netCancel_console(store)
    // IE 2026 09 28 / ODOO-342342: читалки документации листают на месте (Back / Contents) — fe.help.inPlaceDocs (по умолчанию вкл.):
    // helpDocs.get() / .set('inPlaceDocs', false) / .reset() / .stats() / .clear() — см. utils/docsNav.js
    helpDocs_console(store)
    // IE 2026 09 28 / ODOO-5800: форма настроек виджета по требованию — fe.widget.settingsFormLazy / fe.widget.settingsFormPrefetch (по умолчанию вкл.):
    // settingsFormLazy.get() / .set('settingsFormLazy', false) / .reset() / .stats() / .clear() / .load(id) — см. utils/settingsFormLazy.js
    settingsFormLazy_console(store)
    // IE 2026 09 28 / ODOO-342342: меню читалки с поиском по инструкциям — fe.help.docsSearch (по умолчанию вкл.): helpDocs.set('docsSearch', false) / .search()
    docsSearch_console()
    // IE 2026 09 28 / ODOO-342342 (Use cases): «Бизнес-кейсы» — fe.guide.cases (весь фронт кейсов), fe.guide.chipsOnOpen (чипсы показа при открытии страницы, до виджетов), по умолчанию вкл.:
    // guideCases.get() / .set('cases', false) / .reset() / .stats() / .clear() / .session() / .restore() / .end() — см. utils/guideCases.js
    guideCases_console(store, { session: () => store.guideSession, backups: () => store.guide_backups(), restore: () => store.guide_restoreFilters(), end: () => store.guide_end() })

    // АН 2026 08 08: «быстрый пересчёт» — флаги каскада правки ячеек (mainStore.fastRecalc);
    // уходят в запросе save, бэкенд перечитывает их на каждом сохранении
    window.fastRecalc = {
        get: () => JSON.parse(JSON.stringify(store.fastRecalc)),
        set(name, value) {
            if (!(name in store.fastRecalc)) {
                console.warn(`fastRecalc: no option '${name}'. Options:`, Object.keys(store.fastRecalc))
                return
            }
            store.fastRecalc[name] = value
            const saved = (() => { try { return JSON.parse(localStorage.getItem('fastRecalc') || '{}') } catch (e) { return {} } })()
            saved[name] = value
            localStorage.setItem('fastRecalc', JSON.stringify(saved))
            return this.get()
        },
        reset() { localStorage.removeItem('fastRecalc'); location.reload() },
    }

    // IE 2026 08 20 / ODOO-336291 (mobile UX): тумблер мобильного профиля.
    // mobileUi.set('enabled', true|false|null) — форс/авто; класс body применяется сразу
    window.mobileUi = {
        // IE 2026 09 04 / ODOO-336291 (mobile UX): + stats (P-31, см. mobTapDone ниже)
        get: () => ({ ...JSON.parse(JSON.stringify(store.mobileUi)), stats: JSON.parse(JSON.stringify(store._mobTapStats || {})) }),
        set(name, value) {
            if (!(name in store.mobileUi)) {
                console.warn(`mobileUi: no option '${name}'. Options:`, Object.keys(store.mobileUi))
                return
            }
            store.mobileUi[name] = value
            const saved = (() => { try { return JSON.parse(localStorage.getItem('mobileUi') || '{}') } catch (e) { return {} } })()
            saved[name] = value
            localStorage.setItem('mobileUi', JSON.stringify(saved))
            const auto = mobileAuto()   // IE 2026 09 04 / ODOO-336330
            store.mobileUi.on = store.mobileUi.enabled == null ? auto : !!store.mobileUi.enabled
            document.body.classList.toggle('mobile-ui', store.mobileUi.on && store.mobileUi.bigTargets !== false)
            document.body.classList.toggle('shell-lock', store.mobileUi.on && store.mobileUi.shellLock !== false) // IE 2026 08 20 / ODOO-336291 (mobile UX) (Safari/iPhone)
            document.body.classList.toggle('mob-cards', store.mobileUi.on && store.mobileUi.cardsBoard !== false) // IE 2026 08 23 (заказ Игоря)
            document.body.classList.toggle('mob-chain', store.mobileUi.on && store.mobileUi.gridPanChain !== false) // IE 2026 09 04 / ODOO-336291 (mobile UX): P-10 (CSS-часть scroll chaining)
            // IE 2026 09 04 / ODOO-336291 (mobile UX): CSS-части флагов пакета FE-2
            document.body.classList.toggle('mob-onetap', store.mobileUi.on && store.mobileUi.fabsOneTap !== false)
            document.body.classList.toggle('mob-fabspad', store.mobileUi.on && store.mobileUi.fabsPad !== false)
            document.body.classList.toggle('mob-press', store.mobileUi.on && store.mobileUi.pressFeedback !== false)
            document.body.classList.toggle('mob-fast', store.mobileUi.on && store.mobileUi.fastTransitions !== false)
            document.body.classList.toggle('mob-hdrwrap', store.mobileUi.on && store.mobileUi.hdrWordWrap !== false)
            document.body.classList.toggle('mob-railhit', store.mobileUi.on && store.mobileUi.railRowHit !== false)
            // IE 2026 09 04 / ODOO-336291 (mobile UX): пакет FE-4
            document.body.classList.toggle('mob-chartc', store.mobileUi.on && store.mobileUi.chartCompact !== false)
            document.body.classList.toggle('mob-gridglyph', store.mobileUi.on && store.mobileUi.gridGlyphTouch !== false)
            document.body.classList.toggle('mob-setgrid', store.mobileUi.on && store.mobileUi.settingsCompact !== false)
            document.body.classList.toggle('mob-railgrp', store.mobileUi.on && store.mobileUi.railGroupStyle !== false)
            document.body.classList.toggle('mob-fabuni', store.mobileUi.on && store.mobileUi.fabUniform !== false)
            return this.get()
        },
        reset() { localStorage.removeItem('mobileUi'); location.reload() },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31 — таблица задержек тапа по командам; сброс — resetStats()
        stats() { const s = store._mobTapStats || {}; const rows = Object.keys(s).sort().map(k => ({ command: k, ...s[k] })); console.table(rows); return rows },
        resetStats() { store._mobTapStats = {}; return store._mobTapStats },
    }

    // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31 tapStats — задержка «pointerdown → видимый результат» по командам.
    // document pointerdown (capture, passive) запоминает t0 и класс цели; команда в точке «видно»
    // зовёт window.mobTapDone('<name>'), замер снимается во втором rAF (после отрисовки) →
    // store._mobTapStats[name] = {count, lastMs, avgMs, maxMs, target}. Плюс счётчики long tasks
    // (_longtasks) и событий ввода > 16 мс (_inp). Смотреть: window.mobileUi.stats().
    // Выкл: window.mobileUi.set('tapStats', false)
    {
        const TAP_TARGETS = ['mobile-rail-toggle', 'mobile-widgets-toggle', 'p-link-topbar-1', 'widget_menu', 'widget-corner-btn',
            'mob-settings-btn', 'wj-cell', 'tb-right-more', 'mobile-mode-toggle', 'mm-row', 'left-area-button-tab', 'commandPanel-buttons']
        const TAP_SEL = TAP_TARGETS.map(c => '.' + c).join(',')
        let _tapT0 = 0, _tapTarget = ''
        document.addEventListener('pointerdown', (e) => {
            if (!store.mobileUi?.on || store.mobileUi.tapStats === false) return
            _tapT0 = e.timeStamp || performance.now()
            const el = e.target?.closest?.(TAP_SEL)
            _tapTarget = el ? (TAP_TARGETS.find(c => el.classList.contains(c)) || '') : ''
        }, { capture: true, passive: true })
        window.mobTapDone = (name) => {
            if (!store.mobileUi?.on || store.mobileUi.tapStats === false || !_tapT0) return
            const t0 = _tapT0, target = _tapTarget
            requestAnimationFrame(() => requestAnimationFrame(() => {
                const ms = +(performance.now() - t0).toFixed(1)
                if (ms < 0 || ms > 30000) return // тап был давно — не наш
                const st = store._mobTapStats || (store._mobTapStats = {})
                const s = st[name] || (st[name] = { count: 0, lastMs: 0, avgMs: 0, maxMs: 0, target: '' })
                s.count++; s.lastMs = ms; s.avgMs = +((s.avgMs * (s.count - 1) + ms) / s.count).toFixed(1); s.maxMs = Math.max(s.maxMs, ms); s.target = target
            }))
        }
        try {
            new PerformanceObserver((l) => {
                if (!store.mobileUi?.on || store.mobileUi.tapStats === false) return
                const st = store._mobTapStats || (store._mobTapStats = {})
                const s = st._longtasks || (st._longtasks = { count: 0, lastMs: 0, avgMs: 0, maxMs: 0, target: 'totalMs=0' })
                for (const en of l.getEntries()) {
                    const d = Math.round(en.duration), total = (parseInt(String(s.target).split('=')[1], 10) || 0) + d
                    s.count++; s.lastMs = d; s.avgMs = Math.round(total / s.count); s.maxMs = Math.max(s.maxMs, d); s.target = 'totalMs=' + total
                }
            }).observe({ type: 'longtask', buffered: true })
        } catch (e) { /* longtask не поддержан (Safari) */ }
        try {
            new PerformanceObserver((l) => {
                if (!store.mobileUi?.on || store.mobileUi.tapStats === false) return
                const st = store._mobTapStats || (store._mobTapStats = {})
                for (const en of l.getEntries()) {
                    if (!/pointerdown|pointerup|click|touchstart|touchend/.test(en.name)) continue
                    const s = st._inp || (st._inp = { count: 0, lastMs: 0, avgMs: 0, maxMs: 0, target: '' })
                    const d = Math.round(en.duration)
                    s.count++; s.lastMs = d; s.avgMs = +((s.avgMs * (s.count - 1) + d) / s.count).toFixed(1); s.maxMs = Math.max(s.maxMs, d)
                    s.target = en.name + ' ' + ((en.target?.className || '') + '').split(' ').slice(0, 2).join(' ')
                }
            }).observe({ type: 'event', durationThreshold: 16 })
        } catch (e) { /* event timing не поддержан */ }
    }

    // IE 2026 08 21 (заказ Игоря): фокус на активной странице — консольный тумблер
    // (десктоп + мобайл): window.pageFocus.get()/.set('enabled', false)/.reset()
    window.pageFocus = {
        get() { return { ...store.pageFocus, stopped: store._pageFocusStopped || 0 } },
        set(k, v) {
            store.pageFocus = { ...store.pageFocus, [k]: v }
            localStorage.setItem('pageFocus', JSON.stringify(store.pageFocus))
            return store.pageFocus
        },
        reset() { localStorage.removeItem('pageFocus'); location.reload() },
    }

    // IE 2026 08 26 / ODOO-5800 (заказ Игоря «слетают все чипсы»): чипсы стола переживают
    // перезагрузку — window.chipsKeep.get()/.set('enabled', false)/.reset() (reset стирает и снимки)
    window.chipsKeep = {
        get() {
            const keys = Object.keys(localStorage).filter(k => k.startsWith('chipsKeep:'))
            return { ...store.chipsKeep, snapshots: keys.length }
        },
        set(k, v) {
            store.chipsKeep = { ...store.chipsKeep, [k]: v }
            localStorage.setItem('chipsKeep', JSON.stringify(store.chipsKeep))
            return store.chipsKeep
        },
        reset() {
            for (const k of Object.keys(localStorage)) if (k.startsWith('chipsKeep:')) localStorage.removeItem(k)
            localStorage.removeItem('chipsKeep'); location.reload()
        },
    }

    // IE 2026 08 27 / ODOO-5800 (заказ Игоря): линии дерева — window.treeLines.get() (флаг +
    // счётчики formatItem_break/autoSizeRows), .set('mode', 'dotted'|'') — прежний пунктир /
    // плавная рамка (нужна перезагрузка страницы), .reset() — дефолты
    window.treeLines = {
        get() {
            return { ...store.treeLines, stats: { ...(store._treeLinesStats || {}) } }
        },
        set(k, v) {
            if (k === 'mode' && !['', 'dotted', 'frame'].includes(v)) {
                console.warn("treeLines.set('mode', v): v = '' (frame, default) | 'dotted'")
                return store.treeLines
            }
            store.treeLines = { ...store.treeLines, [k]: k === 'mode' && v === 'frame' ? '' : v }
            localStorage.setItem('treeLines', JSON.stringify(store.treeLines))
            console.log('treeLines: reload the page to apply', store.treeLines)
            return store.treeLines
        },
        resetStats() {
            const st = store._treeLinesStats
            if (st) for (const k of Object.keys(st)) st[k] = 0
            return { ...st }
        },
        reset() { localStorage.removeItem('treeLines'); location.reload() },
    }

    // IE 2026 08 29 / ODOO-5828 (заказ Игоря): подсветка остальных вхождений выделенного текста
    // (VS Code-стиль). window.selectionHighlight.get() — флаг + счётчики (supported/requests/
    // repaints/matches/ms), .set('enabled', false) — выключить сразу, .reset() — дефолты
    selectionHighlight.init(store)   // IE 2026 08 29 / ODOO-5828: слушатель selectionchange (нет Highlight API — молча выкл.)
    window.selectionHighlight = {
        get() { return { ...store.selectionHighlight, stats: selectionHighlight.stats() } },
        set(k, v) {
            store.selectionHighlight = { ...store.selectionHighlight, [k]: v }
            localStorage.setItem('selectionHighlight', JSON.stringify(store.selectionHighlight))
            if (k === 'enabled' && !v) selectionHighlight.clear()
            return store.selectionHighlight
        },
        reset() { localStorage.removeItem('selectionHighlight'); location.reload() },
    }

    // IE 2026 08 28 / ODOO-5828 (заказ Игоря «мгновенное открытие»): тайтлы ссылок формы
    // записи готовыми в ответе widget_open — window.recordOpenTitles.get() (флаг + счётчики
    // opens/ids_applied/ids_unmatched/ms), .set('enabled', false) — выключить (сравнение
    // A/B: снова волны get_itemsSource), .reset() — дефолты. Дефолт ВКЛ.
    window.recordOpenTitles = {
        get() {
            return { ...store.recordOpenTitles, stats: { ...(store._recordOpenTitlesStats || {}) },
                skip: [...(store._recordOpenTitlesSkip || [])] }
        },
        // IE 2026 08 29 / ODOO-5828: забыть обученный список «не просить» (после доработки бэка/данных)
        forget() { store._recordOpenTitlesSkip?.clear?.(); return this.get() },
        set(k, v) {
            store.recordOpenTitles = { ...store.recordOpenTitles, [k]: v }
            localStorage.setItem('recordOpenTitles', JSON.stringify(store.recordOpenTitles))
            return store.recordOpenTitles
        },
        reset() { localStorage.removeItem('recordOpenTitles'); location.reload() },
    }

    // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4205): боковые стеки кнопок по умолчанию
    // приоткрыты на 1/3 — тап по приоткрытой кнопке или свайп от края выдвигает стек,
    // обратный свайп (или свайп к краю) прячет. Классы на body читает mobile-ui.css.
    const _applyFabs = () => {
        document.body.classList.toggle('fabs-left-open', !!store.mobileUi?.fabsLeft)
        document.body.classList.toggle('fabs-right-open', !!store.mobileUi?.fabsRight)
        // 21.08: стек спрятан — подписи не живут отдельно от него
        if (!store.mobileUi?.fabsLeft) document.body.classList.remove('fabs-left-tips')
        if (!store.mobileUi?.fabsRight) document.body.classList.remove('fabs-right-tips')
    }
    // НЕ store.$subscribe: он вешает deep-watch на ВЕСЬ стор — Vue traverse обходил
    // wijmo-контролы внутри WIDGET'ов и падал на уничтоженном гриде
    // (TypeError hasColumnGroups of null, скрин Игоря). Точечные вотчеры двух полей:
    _vueWatch(() => store.mobileUi?.fabsLeft, _applyFabs)
    _vueWatch(() => store.mobileUi?.fabsRight, _applyFabs)
    _applyFabs()
    // IE 2026 09 04 / ODOO-336291 (mobile UX): R-3 — режим выделения ячеек → body.mob-select (mobile-ui.css: touch-action грида pan-x pan-y
    // только в нём; в режиме просмотра — pan-y, горизонталь ведёт JS и нативный оверскролл не стартует)
    _vueWatch(() => !!(store.mobileUi?.on && store.mobileUi?.selectMode), (v) => document.body.classList.toggle('mob-select', v), { immediate: true })
    // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08 (скрин Игоря 11:06): топбар с 2+
    // чипсами выше 44px — кнопки виджета и панели позиционируются от его фактической
    // высоты (--mob-topbar-h, читает mobile-ui.css)
    let _tbObserved = null, _tbPoll = null
    const _mobTopbarH = () => {
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-07 — меряем обёртку .topbar (шапка + плашка notification), не только .layout-topbar:
        // контент и кнопки считаются от фактического низа всего блока
        const tb = document.querySelector('.topbar') || document.querySelector('.layout-topbar')
        if (tb && tb !== _tbObserved && window.ResizeObserver) {
            new ResizeObserver(_mobTopbarH).observe(tb); _tbObserved = tb
            // IE 2026 09 04 / ODOO-336291 (mobile UX): P-22 topbarPollStop — ResizeObserver есть: опрос раз в 1.5 с (forced layout всю сессию) не нужен;
            // AppTopbar.mounted зовёт window._mobTopbarSync при (пере)монтировании шапки; одно контрольное чтение через 3 с.
            // Выкл (прежний постоянный опрос): window.mobileUi.set('topbarPollStop', false)
            if (_tbPoll && store.mobileUi?.topbarPollStop !== false) { clearInterval(_tbPoll); _tbPoll = null; setTimeout(_mobTopbarH, 3000) }
        }
        // IE 2026 09 04 / ODOO-336330: запасная высота и период страховочного опроса — настройки базы
        const h = tb ? Math.round(tb.getBoundingClientRect().height) : store.setting('fe.mobile.topbarPx', 44)
        document.documentElement.style.setProperty('--mob-topbar-h', h + 'px')
    }
    _tbPoll = setInterval(_mobTopbarH, store.setting('fe.mobile.topbarPollMs', 1500)) // страховка: топбар монтируется позже main.js
    window._mobTopbarSync = _mobTopbarH // IE 2026 09 04 / ODOO-336291 (mobile UX): P-22 — вызов из AppTopbar.mounted
    _mobTopbarH()
    const FABS_LEFT = '.widget-close-btn,.widget-dots-btn,.widget-panelbar-btn,.widget-bar-btn,.mobile-rail-toggle,.mobile-widgets-toggle'
    const FABS_RIGHT = '.viz-extras-btn,.cell-dropdown-btn,.cell-open-btn,.widget-max-btn,.widget_menu,.button-1,.button-lt'
    // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08 (заказ Игоря): второй свайп от края
    // показывает подписи кнопок стека (CSS ::after content:attr(title) по классам
    // fabs-*-tips); тап по кнопке или обратный свайп подписи снимает
    const _fabTips = { L: false, R: false }
    const _setFabTips = (side, on) => {
        _fabTips[side] = on
        document.body.classList.toggle(side === 'L' ? 'fabs-left-tips' : 'fabs-right-tips', on)
    }
    document.addEventListener('touchend', () => _fabHoldCancel(), { passive: true })
    document.addEventListener('click', (e) => {
        if (!store.mobileUi?.on) return
        // после сработавшего long-press синтетический click не нажимает кнопку
        // и не гасит только что показанные подписи
        if (_fabHoldFired) { _fabHoldFired = false; e.stopPropagation(); e.preventDefault(); return }
        // 21.08: тап мимо кнопок при видимых подписях — тоже снимает их
        if ((_fabTips.L || _fabTips.R) && !e.target.closest?.(FABS_LEFT) && !e.target.closest?.(FABS_RIGHT)) {
            _setFabTips('L', false); _setFabTips('R', false)
        }
        if (e.target.closest?.(FABS_LEFT)) {
            if (_fabTips.L || _fabTips.R) { _setFabTips('L', false); _setFabTips('R', false) }
            if (!store.mobileUi.fabsLeft) {
                store.mobileUi.fabsLeft = true
                // IE 2026 09 04 / ODOO-336291 (mobile UX): B-06 / P-13 fabsOneTap — тот же тап выполняет действие кнопки (click идёт дальше к её
                // обработчику); прежнее: только выдвинуть стек, действие вторым тапом. Выкл: window.mobileUi.set('fabsOneTap', false)
                if (store.mobileUi.fabsOneTap === false) { e.stopPropagation(); e.preventDefault() }
                window.mobileHaptic?.() // IE 2026 08 20 / ODOO-336291 (mobile UX) (Safari/iPhone)
                window.mobTapDone?.('fabExpand') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
            }
        } else if (e.target.closest?.(FABS_RIGHT)) {
            if (_fabTips.L || _fabTips.R) { _setFabTips('L', false); _setFabTips('R', false) }
            if (!store.mobileUi.fabsRight) {
                store.mobileUi.fabsRight = true
                if (store.mobileUi.fabsOneTap === false) { e.stopPropagation(); e.preventDefault() } // IE 2026 09 04 / ODOO-336291 (mobile UX): B-06 fabsOneTap (см. выше)
                window.mobileHaptic?.()
                window.mobTapDone?.('fabExpand') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
            }
        }
    }, true)
    let _fabTouch = null
    // IE 2026 08 21 (заказ Игоря): удержание пальца на боковой кнопке ~0.5с —
    // показать подписи её стека; click, следующий за удержанием, гасится
    let _fabHoldTimer = null, _fabHoldFired = false
    const _fabHoldCancel = () => { if (_fabHoldTimer) { clearTimeout(_fabHoldTimer); _fabHoldTimer = null } }
    // (доработка Игоря): свайп ПРЯМО ПО ПОЛОСЕ КНОПОК (52px у края), порог 20px;
    // preventDefault в полосе — жест не уходит в «возврат странички» браузера
    // IE 2026 08 22 (заказ Игоря 09:31): ЕДИНЫЙ уровень видимости кнопок —
    // 0 скрыто всё (нижний ряд «хвостиком» на треть), 1 только нижние,
    // 2 боковые ОБЕИХ сторон, 3 подписи; свайп внутрь = +1, к краю = −1,
    // одинаково с любого бока и по нижнему ряду
    const _fabLevel = () => {
        if (document.body.classList.contains('fabs-bottom-min')) return 0
        if (!store.mobileUi.fabsLeft && !store.mobileUi.fabsRight) return 1
        return (_fabTips.L || _fabTips.R) ? 3 : 2
    }
    const _setFabLevel = (n) => {
        n = Math.max(0, Math.min(3, n))
        document.body.classList.toggle('fabs-bottom-min', n === 0)
        store.mobileUi.fabsLeft = n >= 2
        store.mobileUi.fabsRight = n >= 2
        _setFabTips('L', n === 3)
        _setFabTips('R', n === 3)
        window.mobileHaptic?.()
    }
    window._setFabLevel = _setFabLevel // для прогонов/консоли
    document.addEventListener('touchstart', (e) => {
        if (!store.mobileUi?.on) return
        const t = e.touches[0]
        const W = window.innerWidth, H = window.innerHeight
        // IE 2026 09 04 / ODOO-336330: ширины зон края — настройки базы (52 / 120 / 300 px)
        const _zEdge = store.setting('fe.mobile.fabEdgeZonePx', 52)
        const _zOpen = store.setting('fe.mobile.fabOpenZonePx', 120)
        const _zTips = store.setting('fe.mobile.fabTipsZonePx', 300)
        const zoneL = _fabTips.L ? _zTips : (store.mobileUi.fabsLeft ? _zOpen : _zEdge)
        const zoneR = _fabTips.R ? _zTips : (store.mobileUi.fabsRight ? _zOpen : _zEdge)
        // нижний ряд (кнопки страниц/режима, включая «хвостик» уровня 0)
        const bottom = t.clientY > H - 130 && t.clientX <= 240
        const side = bottom ? 'B' : (t.clientX <= zoneL ? 'L' : (t.clientX >= W - zoneR ? 'R' : null))
        _fabTouch = side ? { x: t.clientX, y: t.clientY, side } : null
        if (_fabTouch) _edgeMoveAttach() // IE 2026 09 04 / ODOO-336291 (mobile UX): P-27 — non-passive touchmove только на время касания у края
        // long-press по кнопке стека → подписи стороны
        const btnSide = e.target.closest?.(FABS_LEFT) ? 'L' : (e.target.closest?.(FABS_RIGHT) ? 'R' : null)
        _fabHoldFired = false
        _fabHoldCancel()
        if (btnSide) {
            _fabHoldTimer = setTimeout(() => {
                _fabHoldTimer = null; _fabHoldFired = true
                _setFabTips(btnSide, true)
                window.mobileHaptic?.()
            }, store.setting('fe.mobile.fabLongPressMs', 500))   // IE 2026 09 04 / ODOO-336330
        }
    }, { passive: true })
    // IE 2026 09 04 / ODOO-336291 (mobile UX): P-27 edgeSwipePassive — постоянный non-passive touchmove на document заставлял браузер ждать
    // main thread перед стартом ЛЮБОГО тач-скролла (гриды, лента, списки). Теперь постоянный слушатель passive
    // (только отмена long-press), а non-passive для свайпа от края вешается в touchstart, когда касание в зоне края,
    // и снимается по touchend/touchcancel. Выкл (прежнее: постоянный non-passive): window.mobileUi.set('edgeSwipePassive', false)
    // — применяется при загрузке страницы.
    const _edgeMove = (e) => {
        if (!_fabTouch || !store.mobileUi?.on) return
        const t = e.touches[0]
        const dx = t.clientX - _fabTouch.x, dy = t.clientY - _fabTouch.y
        if (Math.abs(dy) > Math.abs(dx) + 8) { _fabTouch = null; return } // вертикальный скролл — не наш
        e.preventDefault()
        if (Math.abs(dx) < store.setting('fe.mobile.fabSwipePx', 20)) return   // IE 2026 09 04 / ODOO-336330
        // внутрь экрана = раскрыть больше, к краю = спрятать; действует на всё
        const inward = _fabTouch.side === 'R' ? dx < 0 : dx > 0
        _setFabLevel(_fabLevel() + (inward ? 1 : -1))
        _fabTouch = null
    }
    const _edgePassive = store.mobileUi?.edgeSwipePassive !== false
    let _edgeMoveOn = false
    const _edgeMoveAttach = () => { if (_edgePassive && !_edgeMoveOn) { document.addEventListener('touchmove', _edgeMove, { passive: false }); _edgeMoveOn = true } }
    const _edgeMoveDetach = () => { if (_edgeMoveOn) { document.removeEventListener('touchmove', _edgeMove); _edgeMoveOn = false } }
    document.addEventListener('touchmove', (e) => {
        // заметное движение отменяет long-press (это свайп/скролл, не удержание)
        if (_fabHoldTimer) {
            const t0 = e.touches[0]
            if (!_fabTouch || Math.abs(t0.clientX - _fabTouch.x) + Math.abs(t0.clientY - _fabTouch.y) > store.setting('fe.mobile.fabLongPressMovePx', 12)) _fabHoldCancel()   // IE 2026 09 04 / ODOO-336330
        }
        if (!_edgePassive) _edgeMove(e)
    }, { passive: _edgePassive })
    document.addEventListener('touchend', _edgeMoveDetach, { passive: true })
    document.addEventListener('touchcancel', _edgeMoveDetach, { passive: true })

    // IE 2026 08 20 / ODOO-336291 (mobile UX) (Safari/iPhone, research 20.08): системные
    // интеграции, все под флагами mobileUi.* (дефолты ВКЛ — правило опций)
    // 1) Тактильный отклик: switch-контрол Safari 17.4+ даёт Taptic-клик на .click()
    //    (на iOS 26.5+ программный путь закрыт — тихий no-op); Android — vibrate
    window.mobileHaptic = () => {
        try {
            if (!store.mobileUi?.on || store.mobileUi.haptics === false) return
            if (navigator.vibrate) { navigator.vibrate(store.setting('fe.mobile.hapticMs', 10)); return }   // IE 2026 09 04 / ODOO-336330
            let sw = document.getElementById('mob-haptic-switch')
            if (!sw) {
                sw = document.createElement('input')
                sw.type = 'checkbox'
                sw.id = 'mob-haptic-switch'
                sw.setAttribute('switch', '')
                sw.style.cssText = 'position:fixed;left:-99px;top:-99px;width:1px;height:1px;opacity:.01;pointer-events:none'
                document.body.appendChild(sw)
            }
            sw.click()
        } catch (e) { /* no-op */ }
    }
    // 2) Wake lock: экран не гаснет, пока виджет максимизирован (Widget.mobileToggleMax);
    //    ОС снимает лок при сворачивании — на возврате берём заново
    let _wakeSentinel = null, _wakeWanted = false
    window.mobileWakeLock = async (on) => {
        _wakeWanted = !!on && !!store.mobileUi?.on && store.mobileUi.wakeLock !== false
        try {
            if (_wakeWanted && 'wakeLock' in navigator) _wakeSentinel = await navigator.wakeLock.request('screen')
            else { _wakeSentinel?.release?.(); _wakeSentinel = null }
        } catch (e) { _wakeSentinel = null /* iOS 16.4-18.3 standalone: недоступен, молча */ }
    }
    document.addEventListener('visibilitychange', () => {
        if (_wakeWanted && document.visibilityState === 'visible') window.mobileWakeLock(true)
    })
    // 3) Клавиатура iOS ложится ПОВЕРХ fixed-кнопок — прятать их, пока открыта
    if (window.visualViewport) {
        const _kb = () => {
            const on = store.mobileUi?.on && store.mobileUi.kbdAware !== false
                && (window.innerHeight - window.visualViewport.height > store.setting('fe.mobile.kbdOpenThresholdPx', 150))   // IE 2026 09 04 / ODOO-336330
            document.body.classList.toggle('kbd-open', !!on)
        }
        window.visualViewport.addEventListener('resize', _kb)
        // iOS 26.0: offsetTop не сбрасывается после клавиатуры — вернуть вьюпорт
        // IE 2026 10 14 (owner-direct, шина #85128: iPad — «смещается экран, не видно верхней строки»): iPad шире порога мобильного профиля
        // (mobileUi выключен), а клавиатура сдвигает документ так же — сброс и на любом сенсорном экране (pointer: coarse), плюс по resize/scroll
        // visualViewport: клавиатура закрылась, а документ остался сдвинутым (body overflow:hidden — пользователь сам его не вернёт)
        const _touch = () => { try { return window.matchMedia('(pointer: coarse)').matches } catch (e) { return false } }
        const _editing = () => { const a = document.activeElement; return !!a && a !== document.body && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable) }
        const _vpReset = () => {
            const se = document.scrollingElement || document.documentElement
            if (window.visualViewport.scale > 1.01) return   // пользователь увеличил щипком — его панорамирование не трогаем
            if (!_editing() && ((se && (se.scrollTop || se.scrollLeft)) || window.visualViewport.offsetTop > 0)) window.scrollTo(0, 0)
        }
        document.addEventListener('focusout', () => {
            if (!store.mobileUi?.on && !_touch()) return
            setTimeout(() => {
                const a = document.activeElement
                if (!a || a === document.body) window.scrollTo(0, 0)
            }, store.setting('fe.mobile.kbdScrollResetMs', 60))   // IE 2026 09 04 / ODOO-336330
        })
        if (_touch()) {
            window.visualViewport.addEventListener('resize', () => setTimeout(_vpReset, store.setting('fe.mobile.kbdScrollResetMs', 60)))
            window.visualViewport.addEventListener('scroll', () => setTimeout(_vpReset, store.setting('fe.mobile.kbdScrollResetMs', 60)))
        }
    }
    // 4) Свайп «назад» Safari: сентинел-запись в истории — попадание на неё
    //    закрывает мобильные меню и остаётся в приложении (не выкидывает с сайта)
    // IE 2026 09 04 / ODOO-336291 (mobile UX): R-3 (верификация 04.09) — сентинел лежит ПОД текущей записью, а не над ней.
    //    Прежний порядок [текущая, сентинел] с пользователем на сентинеле: первый «назад» попадал на текущую
    //    (обработчик молчит), второй уводил с сайта; серия свайпов = серия «назад» = 2–3 записи. Теперь
    //    [сентинел, plain-копия]: каждый «назад» приходит на сентинел → меню закрыты, поверх снова plain-копия —
    //    за один жест не больше одной записи и без ухода из приложения. Взводится по первому взаимодействию
    //    (pointerdown/keydown): pushState без user activation помечает предыдущую запись пропускаемой для «назад»
    //    (Chrome history-manipulation intervention) — сентинел, поставленный при загрузке, перепрыгивался бы.
    if (store.mobileUi?.on && store.mobileUi.backGuard !== false && !store.mobileUi.standalone) {
        const plainOf = (st) => { const o = { ...(st || {}) }; delete o.mobSentinel; return o }
        let armed = false
        const arm = () => {
            if (armed || !store.mobileUi?.on || store.mobileUi.backGuard === false) return
            armed = true
            try {
                history.replaceState({ ...(history.state || {}), mobSentinel: 1 }, '')
                history.pushState(plainOf(history.state), '')
            } catch (e) { /* no-op */ }
        }
        for (const t of ['pointerdown', 'keydown']) window.addEventListener(t, arm, { capture: true, passive: true, once: true })
        window.addEventListener('popstate', (e) => {
            if (!e.state?.mobSentinel || !store.mobileUi?.on || store.mobileUi.backGuard === false) return
            const m = store.mobileUi
            m.railOpen = false; m.widgetsOpen = false; m.fabsLeft = false; m.fabsRight = false
            try { history.pushState(plainOf(history.state), '') } catch (e2) { /* no-op */ }
        })
    }

    // Inject X-Database header on every ajax request — nginx route_resolver на новой
    // инфре маршрутизирует по нему. Backward compatible: старые backend'ы игнорируют.
    //
    // ODOO-3705: prefilter'ы jQuery выполняются в порядке регистрации, и этот шёл ПОСЛЕ
    // заведённого в initAjaxDefaults — то есть побеждал. Пока он брал dbid из хэша, он
    // возвращал устаревшее значение (в router.beforeEach хэш ещё от ПРЕЖНЕЙ базы) и сводил
    // на нет маршрутизацию по текущей базе. Логика здесь та же, что в initAjaxDefaults:
    // источник истины — store, хэш только пока база не выбрана.
    if (typeof window !== 'undefined' && window.$) {
        window.$.ajaxPrefilter(function(options) {
            try {
                var h = window.location.hash || ''
                var hashDbid = (h.match(/\/(database_[^?/]+)/) || [])[1] || ''
                var target = (store.user && store.user.database && store.user.database.dbid) || hashDbid
                if (target) {
                    if (!options.headers) options.headers = {}
                    options.headers['X-Database'] = target
                    var oldBeforeSend = options.beforeSend
                    options.beforeSend = function(jqXHR) {
                        jqXHR.setRequestHeader('X-Database', target)
                        if (oldBeforeSend) return oldBeforeSend.apply(this, arguments)
                    }
                }
            } catch (e) { /* noop */ }
        })
    }

    app.component('WidgetAttrs', WidgetAttrs);
    app.component('Widget', Widget);
    app.component('MenuPanel', MenuPanel); // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2)
    app.component('AttrTab', AttrTab);
    app.component('AttrTabRow', AttrTabRow);
    app.component('Attr', Attr);
    app.component('AttrStr', AttrStr);
    app.component('AttrHTML', AttrHTML);
    app.component('ApprovalOverview', ApprovalOverview);   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE3
    app.component('AttrLabel', AttrLabel);
    app.component('AttrSeparator', AttrSeparator);
    app.component('AttrFlowchart', AttrFlowchart);
    app.component('AttrLink', AttrLink);
    app.component('AttrLinkOdoo', AttrLinkOdoo);
    app.component('AttrBool', AttrBool);
    app.component('AttrButton', AttrButton);
    app.component('AttrMenu', AttrMenu);
    app.component('AttrCommandPanel', AttrCommandPanel);
    app.component('AttrNumber', AttrNumber);
    app.component('AttrDate', AttrDate);
    app.component('AttrTime', AttrTime);
    app.component('AttrGrid', AttrGrid);
    app.component('AttrTabGridLanes', AttrTabGridLanes);
    // группа гридов (секции печати): тип атрибута = компонент = AttrGridGroup
    app.component('AttrGridGroup', AttrGridGroup);
    app.component('AttrCrossGrid', AttrCrossGrid);   // IE 2026 10 25 / ODOO-348878
    app.component('AttrSheet', AttrSheet);
    app.component('AttrTree', AttrTree);
    app.component('AttrGantt', AttrGantt);
    app.component('AttrTabPanel', AttrTabPanel);
    app.component('AttrJSON', AttrJSON);
    app.component('AttrImage', AttrImage);
    app.component('AttrUrl', AttrUrl);   // IE 2026 10 18 / ODOO-347310: ссылка в систему-источник
    app.component('AttrImageUrl', AttrImageUrl);   // IE 2026 10 18 / ODOO-347310: изображение записи (S3 через /api/object_image/)
    app.component('AttrFileViewer', AttrFileViewer);
    app.component('AttrCSS', AttrCSS);
    app.component('AttrMD', AttrMD);
    app.component('AttrStrMulti', AttrStrMulti);
    app.component('AttrDebugger', AttrDebugger);
    app.component('AttrChat', AttrChat);
    app.component('AttrChart', AttrChart);
    app.component('AttrBubbleChart', AttrBubbleChart);
    app.component('AttrGeoMap', AttrGeoMap);   // IE 2026 09 14 / ODOO-5800
    app.component('AttrGanttMoves', AttrGanttMoves);
    app.component('AttrTransitionsGraph', AttrTransitionsGraph);   // IE 2026 10 16 / ODOO-5800
    app.component('AttrAnalysis', AttrAnalysis);   // IE 2026 09 22 / ODOO-5800   // IE 2026 09 22 / ODOO-5800
    app.component('AttrPmHistory', defineAsyncComponent(() => import(/* webpackChunkName: "pm-history" */ './components/widgets/components_core/AttrPmHistory.vue')));   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: вкладка History of changes в отчёте, вариант A): вкладка tab-pm-history отчёта (widget_REPORT2.append_pm_history_tab)
    app.component('AttrHeatmap', defineAsyncComponent(() => import(/* webpackChunkName: "list-heatmap" */ './components/widgets/components_core/AttrHeatmap.vue')));   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: вкладка Heatmap списка): вкладка tabHeatmap списка (тело attr_type AttrHeatmap, viewParams.dataHeatmap)
    app.component('AttrHeatmapGrid', defineAsyncComponent(() => import(/* webpackChunkName: "list-heatmap" */ './components/widgets/components_core/AttrHeatmapGrid.vue')));   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: теплова карта на базі таблиці — порівняльна вкладка): вкладка tabHeatmapGrid — та же теплокарта на AttrGrid
    app.component('AttrListHistory', defineAsyncComponent(() => import(/* webpackChunkName: "list-history" */ './components/widgets/components_core/AttrListHistory.vue')));   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): вкладка tab-list-history списка (widget_LIST.append_list_history_tab, тело attr_type AttrListHistory)
    app.component('AttrRefsTab', defineAsyncComponent(() => import(/* webpackChunkName: "refs-tab" */ './components/widgets/components_core/AttrRefsTab.vue')));   // webscm 2026 10 31 / Odoo 350449: вкладка References формы записи (бэк attrs.get_view → tabRefs, тело attr_type AttrRefsTab; настройка базы search.refs_tab)
    app.component('AttrKpiTiles', defineAsyncComponent(() => import(/* webpackChunkName: "kpi-tiles" */ './components/widgets/components_core/AttrKpiTiles.vue')));   // webscm 2026 10 31 / Odoo 347310: плитки KPI над строками списка (attr_type AttrKpiTiles во вкладке списка, binding _doc.data); нигде не используется, пока запись виджета не положит его во вкладку
    app.component('AttrAntFlow', AttrAntFlow);   // IE 2026 09 15 / ODOO-… (заказ Игоря)
    app.component('AttrBubbleWithAnimationChart', AttrBubbleWithAnimationChart);
    app.component('AttrTreeMap', AttrTreeMap);
    app.component('AttrPivotTool', AttrPivotTool);
    app.component('EmptyIcon', EmptyIcon);
    app.component('AttrGraph', AttrGraph);
    app.component('AttrSchemeGraph', AttrSchemeGraph);   // IE 2026 10 25 / ODOO-348925
    // Odoo 348733: граф DataHub «линза» (three.js) — отдельный ленивый чанк: грузится, только когда виджет выбрал движок опцией graphEngine = 'lens'
    app.component('AttrGraphLens', defineAsyncComponent(() => import(/* webpackChunkName: "graph-lens" */ './components/widgets/components_core/AttrGraphLens.vue')));
    app.component('GraphEngineToggle', GraphEngineToggle);   // Odoo 348733: кнопка «Classic / Lens» в островке графа (AttrGraph и линза)
    app.component('AttrCompare', AttrCompare);
    app.component('AttrStyleStats', AttrStyleStats);
    app.component('AttrTasksPanel', AttrTasksPanel);   // IE 2026 09 23 / ODOO-… (заказ Игоря): вкладка «Tasks panel»
    app.component('AttrUseCaseMenu', AttrUseCaseMenu);   // IE 2026 09 28 / ODOO-342342 (Use cases): вкладка Contents формы USE-CASE
    app.component('AttrChips', AttrChips);
    app.component('Dropdown', Dropdown);
    app.component('Search', Search);

    if (use_callgraph) {
        app.use(createVueCallgraphPlugin(cg));
    }
    // app.config.globalProperties.$printCallTree({ max_depth:12, max_children:50, unit_sec:1e-3 });

    i18nReady.catch(e => console.warn('i18n init failed', e)).then(() => app.mount('#app'));   // IE 2026 09 23 / ODOO-341407: монтирование после словаря и культуры
    
// })();